import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { createData, getList } from "../../hooks/api/utils";
// import Editor from "react-simple-wysiwyg";
import ReactQuill from "react-quill-new";

const AddNewServices = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: "",
    title: "",
    description: "",
    image: null,
    // features: '',
    is_active: "true",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const getData = async () => {
    await getList("/admin-panel/active-industries/", setLoading);
  };

  useEffect(() => {
    getData();
  }, []);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Description is required";
    }

    if (!formData.image) {
      newErrors.image = "Image is required";
    }

    // if (!formData.features.trim()) {
    //   newErrors.features = 'Features are required';
    // }

    if (formData.is_active !== "true" && formData.is_active !== "false") {
      newErrors.is_active = 'is_active must be "true" or "false"';
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
      if (name === "image" && file) {
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setErrors({});
  };

    const handleEditorChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const payload = new FormData();

    for (const key in formData) {
      if (formData[key] !== null && formData[key] !== undefined) {
        payload.append(key, formData[key]);
      }
    }
    setIsSubmitting(true);
    await createData(
      "/admin-panel/services/",
      setIsSubmitting,
      payload,
      navigate,
      "/services"
    );
  };

  return (
  
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Add Service</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Service name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter service name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="text-danger">{errors.name}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Title of question to display
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter question to display"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                        />
                        {errors.title && (
                          <div className="text-danger">{errors.title}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Description<span className="text-danger">*</span>
                        </label>
                        {/* <textarea
                          placeholder="Enter Description"
                          rows={"4"}
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                        />
                        {errors.description && (
                          <div className="text-danger">
                            {errors.description}
                          </div>
                        )} */}
                      <ReactQuill
                        value={formData.description}
                        onChange={handleEditorChange}
                        theme="snow"
                         style={{ minHeight: '160px', marginBottom: '40px', height:'200px' }}
                      />
                      {errors.description && (
                        <div className="text-danger">
                          {errors.description}
                        </div>
                      )}
                      </div>
                    </div>
                    <div className="col-md-12">
           
                      <div className="form-group">
                        <label>
                          Add Picture<span className="text-danger">*</span>
                        </label>
                        <div className="custom-file-upload">
                          <input
                            type="file"
                            id="fileInput"
                            hidden
                            name="image"
                            onChange={handleChange}
                          />
                          <label htmlFor="fileInput" className="upload-box">
                            <span>
                              {formData.image ? formData.image.name : "Upload"}
                            </span>
                            <FaUpload className="upload-icon" />
                          </label>
                          {errors.image && (
                            <div className="text-danger">{errors.image}</div>
                          )}
                        </div>

                        {previewImage && (
                          <div className="mt-3 position-relative" style={{ display: "inline-block" }}>
                            <img
                              src={previewImage}
                              alt="Preview"
                              style={{ width: "200px", borderRadius: "8px" }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  image: null,
                                }));
                                setPreviewImage(null);
                              }}
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                background: "red",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                cursor: "pointer",
                                fontWeight: "bold",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div classNameName="col-md-12">
                      <div className="d-flex gap-3 justify-content-end">
                        <NavLink
                          to={"/services"}
                          type="button"
                          className="transparent_btn"
                        >
                          Cancel
                        </NavLink>
                        <button
                          type="submit"
                          className="blue_btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default AddNewServices;
